const getMap = () => {
	return new Promise(resolve => {
		const check = () => {
			if (window.map) resolve(window.map);
			setTimeout(check, 100);
		};

		check();
	});
};

export default getMap;
